import type { Verbiage } from "@repo/models";

import { useQuery } from "@tanstack/react-query";

import { useLocationPortalApi } from "./locationPortalApi";
import { VERBIAGE } from "./queries";

const controller = "Locations";

export function useVerbiageQuery() {
	const { Get } = useLocationPortalApi(controller);

	const defaultVerbiage = {
		fieldAudit: "Field Audit",
		location: "Location",
		office: "Office",
		marketer: "Marketer",
		partner: "Partner",
		partnerType: "Partner Type",
		retailLocation: "Retail Location",
	};

	const { data: verbiage, isFetching: verbiageLoading } = useQuery({
		queryKey: [VERBIAGE],
		queryFn: () => Get<Verbiage>("GetVerbiage"),
		placeholderData: defaultVerbiage,
	});

	return { ...verbiage, verbiageLoading };
}
